module.exports = __webpack_public_path__ + "assets/images/02_active_f7e0e93e6caaf78bd357e56f3e67e771.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/02_active.png
// module id = 167
// module chunks = 0